<template>
  <div>
    <ModuleHeader>Historico de Ingresos a CXC </ModuleHeader>
    <v-overlay :value="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col md="3" cols="12" class="input">
                <label>Fecha inicial</label>
                <Datepicker @input="getAperturas()" @selected="selectDate" :value="input_date.format('MM/DD/YYYY')">
                </Datepicker>
              </v-col>
              <v-col md="3" class="input">
                <label>Fecha final</label>
                <Datepicker @input="getAperturas()" @selected="selectDateFinal" :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
              </v-col>
              <v-col md="3" cols="12">
                <v-autocomplete @input="getAperturas()" label="Departamentos" v-model="selectDep" item-text="Nombre"
                  item-value="id" :items="departamentos"></v-autocomplete>
              </v-col>
              <v-col cols="1" md="3">
                <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                  :items="turnosList">
                  <template v-slot:append-outer>
                    <v-btn @click="getAperturas()" x-small color="primary">Buscar turnos</v-btn>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col md="3" cols="12" class="mt-n6">
                <v-autocomplete label="Cliente" v-model="selectClient" :items="comp_clients"></v-autocomplete>
              </v-col>
              <v-col md="3" cols="12" class="mt-n6">
                <v-text-field v-model="input_folio" label="Folio de Venta"></v-text-field>
              </v-col>
              <v-col md="3" cols="12" class="mt-n6">
                <v-text-field v-model="input_orden" label="Numero de orden"></v-text-field>
              </v-col>
              <v-col md="12" cols="12">
                <v-btn depressed @click="cleanFilter()" small color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="getVentas();" small color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="12" cols="12">


        <!-- <v-btn style="right: 0; position: absolute;" color="green" dark
              @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon>
              Exportar a Excel
            
            </v-btn> -->
        <DataTable class="mt-12" :config="config" :data="ventas_comp" :pageRows="50" @buttonClick="dtButtonClick">
        </DataTable>

      </v-col>
    </v-row>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :key="resKey" :selectedRes="selectedRes" />
    </modal>
  </div>
</template>

<style scoped></style>

<script>
import "../../../assets/css/sideBar.css";
import Cliente from "../../../clases/Cliente.js";
import Modificadores from "../../../clases/Modificadores.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import resumenVenta from "../../MainComponents/resumenVenta.vue";

import ticket from "../../../tickets/ticketReprint.vue";
import ticketDevolucion from "../../../tickets/ticketDevolucion.vue";
import TicketVenta from "../../../clases/TicketVenta.js";
import DataTable from "../../MainComponents/DataTable.vue";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel.js";
import Currencies from "../../../clases/Currencies";
export default {
  name: "CXCLog",
  components: {
    DataTable,
    Datepicker,
    /*Select2,*/

    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      cajeros: [],
      familias: [],
      keyResume: 0,
      selectTurno: "ALL",
      aperturas: [],
      input_orden: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      data_devoluciones: [],
      processed_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      selectDep: "ALL",
      dataToTicket: {},
      meseros: [],
      resKey: 0,
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: false,
        allowExport: true,
        rawText: "Ventas",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
        ],
        fields: [
          {
            text: "Folio",
            value: "Folio",
          },
          {
            text: "Cliente",
            value: "NombreCliente",
          },
          {
            text: "Meseros",
            value: "allMeseros",
          },
          {
            text: "Alias de venta",
            value: "AliasVenta",
          },
          {
            text: "Fecha",
            value: "fecha",
          },
          {
            text: "Caja",
            value: "CajaName",
            canBeFiltered: true,
          },
          {
            text: "Cajero",
            value: "CajeroName",
            canBeFiltered: true,
          },
          {
            text: "Total",
            value: "Total",
            format: (row) => {
              if (row.isDevolucion) {
                return "$ " + this.$pgsHelper.formatNumber(row.Total.C);
              } else {
                return "$ " + this.$pgsHelper.formatNumber(row.Total);
              }

            },
          },
          {
            text: "Cambio",
            value: "Cambio",
            format: (row) => {
              if (row.Cambio[Currencies.getCurrencyDefault()]) {
                return "$ " + this.$pgsHelper.formatNumber(row.Cambio[Currencies.getCurrencyDefault()]);
              } else {
                return "0"
              }
            },
          },
          {
            canBeFiltered: true,
            text: "Estatus",
            value: "Devos",
            format: (row) => {
              if (row.isDevolucion) {
                return '<b class="orange--text">Devolución</b>'
              } else if (!row.Devos) {
                return '<b class="green--text">Activo</b>'
              } else {
                return '<b class="primary--text">Con devolución</b>'
              }
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "green",
                text: "Detalles",
                buttonId: "showDetail",
                value: "id",
                showBy: "isVenta",

              },
              {
                color: "green",
                text: "Ticket",
                buttonId: "printTicket",
                value: "id",
                showBy: "id",

              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    excelDataFacturacion() {
      let tickets = [];
      this.ventas_comp.map(async (venta) => {
        if (venta.Total != 0) {
          if (
            !venta._ProdIdx.includes("MBS-Movimiento") &&
            !venta._ProdIdx.includes("-NMZKJ2fyTWAv4maSf9M") &&
            !venta._ProdIdx.includes("Monedero")
          ) {
            tickets.push({
              Folio: venta.Folio,
              Cliente: venta.Cliente.Nombre,
              Alias: venta.Cliente.Apodo,
              Fecha: venta.fecha,
              Total: venta.Total,
              Cambio: venta.Cambio?.MXN,
            });
          }
        }
      });
      return tickets;
    },
    excelData() {
      let tickets = [];
      this.ventas_comp.map(async (venta) => {
        tickets.push({
          Folio: (venta.isDevolucion) ? "-" + venta.Folio : venta.Folio,
          Cliente: venta.Cliente.Nombre,
          Alias: venta.Cliente.Apodo,
          Fecha: venta.fecha,
          Total: (venta.isDevolucion) ? 0 - venta.Total.C : venta.Total,
          Cambio: venta.Cambio.MXN,
        });
      });
      return tickets;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });

      return pagos;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    ventas_comp() {
      return this.processed_ventas;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },

    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto() });
      });
      return clientes;
    },
  },
  methods: {
    processAllSales() {
      const meserosMap = this.$pgsHelper.createIndex(this.meseros, 'id');
      this.data_ventas.forEach((venta) => {
        let totales = 0;
        venta.isVenta = true;
        venta.allMeseros = [];
        for (const property in venta.Catalogo) {
          let totalProd = 0;
          if (venta.Catalogo[property].Modificadores) {
            venta.Catalogo[property].ModificadoresList =
              Modificadores.parseToListOption(
                venta.Catalogo[property].Modificadores
              );
            let totalModi = 0;
            venta.Catalogo[property].ModificadoresList.forEach((modi) => {
              totalModi += modi.pco.C;
            });
            venta.Catalogo[property].totalModi = totalModi;
          }
          if (venta.Catalogo[property].Pagos) {
            Object.entries(venta.Catalogo[property].Pagos).forEach((pago) => {
              totales += pago[1].def.C;
              if (new moment(venta.FechaCreacion).format("YYYY") == "2023") {
                if (venta.Catalogo[property].STip == "Cuenta") {
                  pago[1].def.C = pago[1].def.C + pago[1].dsc.C * -1;
                  pago[1].dsc.C = 0;
                  venta.Catalogo[property].Descuentos = [];
                }
              }
              totalProd += pago[1].def.C;
            });
          }
          if (venta.Catalogo[property].ExtraParams?.AYB) {
            const meseroNombre =
              meserosMap.get(venta.Catalogo[property].ExtraParams.AYB.Mesero)?.Nombre || "Sin mesero";
            if (!venta.allMeseros.includes(meseroNombre)) {
              venta.allMeseros.push(meseroNombre);
            }
          }
          venta.Catalogo[property].TotalReal = Number(totalProd);
        }
        venta.sumatoriaTotal = totales;
      });
      this.data_devoluciones.forEach((venta) => {
        let totales = 0;
        venta.Cambio = { MXN: 0 };
        venta.isDevolucion = true;
        for (const property in venta.Catalogo) {
          let totalProd = 0;
          if (venta.Catalogo[property].Modificadores) {
            venta.Catalogo[property].ModificadoresList =
              Modificadores.parseToListOption(
                venta.Catalogo[property].Modificadores
              );
            let totalModi = 0;
            venta.Catalogo[property].ModificadoresList.forEach((modi) => {
              totalModi += modi.pco.C;
            });
            venta.Catalogo[property].totalModi = totalModi;
          }
          if (venta.Catalogo[property].Pagos) {
            Object.entries(venta.Catalogo[property].Pagos).forEach((pago) => {
              totales += pago[1].def.C;
              if (new moment(venta.FechaCreacion).format("YYYY") == "2023") {
                if (venta.Catalogo[property].STip == "Cuenta") {
                  pago[1].def.C = pago[1].def.C + pago[1].dsc.C * -1;
                  pago[1].dsc.C = 0;
                  venta.Catalogo[property].Descuentos = [];
                }
              }
              totalProd += pago[1].def.C;
            });
          }
          venta.Catalogo[property].TotalReal = Number(totalProd);
        }
        venta.sumatoriaTotal = totales;
      });
      let data = this.data_ventas.concat(this.data_devoluciones);
      let array = data.sort(function (a, b) {
        if (
          Number(b.Folio.replace(/\D/g, "")) >
          Number(a.Folio.replace(/\D/g, ""))
        )
          return -1;
        if (
          Number(b.Folio.replace(/\D/g, "")) <
          Number(a.Folio.replace(/\D/g, ""))
        )
          return 1;
      });
      this.processed_ventas = array;
    },
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excelData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Reporte Venta.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "showDetail") {
        let venta = this.$pgsHelper.getById(this.ventas_comp, "id", idSelected);
        this.showDetail(venta);
      }
      if (buttonId == "printTicket") {
        let venta = this.$pgsHelper.getById(this.ventas_comp, "id", idSelected);
        this.printTicket(venta);
      }
    },
    async printMasiveTicket(ticketHtml) {
      let html = "";
      let cssTicket = await this.$pgsHelper.getTicketCss();
      setTimeout(async () => {
        html += "<html><head><title>" + document.title + "</title>";
        html += "<style>" + cssTicket + "</style>";
        html += "</head><body >";

        html += ticketHtml;
        html += "</body></html>";
        this.$pgsHelper.printTicket(this, html);
      }, 2000);
    },
    async getTipoCambio(id) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("PDV_TipoCambio", id);

      const tc = await firestore.getDoc(doc);
      let tcdoc = { Id: tc.ref.id, ...tc.data() };
      return tcdoc;
    },
    async printTicket(res, sinPrecio = false) {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/CONF/" + res.Departamento
        );
      let resultConf = data.val();
      let cssTicket = await this.$pgsHelper.getTicketCss();
      let tipoCambio = await this.getTipoCambio(res.TipoCambio);
      res.TC = tipoCambio.TC;
      let dataToTicket = res;
      if (!dataToTicket.isVenta) {
        res.FechaVenta = res.Fecha
      }
      let Cajero = this.$pgsHelper.getById(this.cashiers, "Id", res.Cajero);
      dataToTicket.cajero = { NombreCajero: Cajero.Nomb || "Sin Cajero" };
      dataToTicket.sinPrecio = sinPrecio;
      dataToTicket.Depto = resultConf;
      let TVenta = new TicketVenta(dataToTicket);
      TVenta.dataToTicketReprint();
      console.log(TVenta);

      let ticketHtml = this.$pgsHelper.getHtmlFromComponent(
        this,
        res.isVenta ? ticket : ticketDevolucion,
        {
          dataToTicket: TVenta,
          currenciDefault: Currencies.getCurrencyDefault(),
        }
      );
      let html = "";
      //let stylesHtml = "";
      setTimeout(async () => {
        /*for (const node of [
          ...document.querySelectorAll('link[rel="stylesheet"], style'),
        ]) {
          stylesHtml += node.outerHTML;
        }*/

        html += "<html><head><title>" + document.title + "</title>";
        html += "<style>" + cssTicket + "</style>";
        //html+= stylesHtml
        html += "</head><body >";

        html += ticketHtml;
        html += "</body></html>";
        /* if (this.$pgsHelper.getConfig("useServerPrinter")) {
          this.$pgsHelper.printerInServerPrinter(
            "<body>" + ticketHtml + "</body>",
            "<style>" + cssTicket + "</style>",
            "TICKET-PRINTER"
          );
        } else {*/
        /*let defaultPreviousPrinter = await this.$pgsHelper.getDefaultPrinter(
            this
          );
          let printer = this.$pgsHelper.getPrinter("tickets");
          if (printer != false) {
            await this.$pgsHelper.usePrinter(printer);
          }*/
        this.$pgsHelper.printTicket(this, html);
        /* }*/
        //this.$pgsHelper.printTicket(this, html,defaultPreviousPrinter);
      }, 2000);
    },
    async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }

      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      const cajasMapA = this.$pgsHelper.createIndex(this.data_cajas, 'id');
      const cajerosMapA = this.$pgsHelper.createIndex(this.cajeros, 'Id');
      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = cajasMapA.get(apt.Caja) || {};
        let cajeroData = cajerosMapA.get(apt.Cajero) || {};
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    cleanFilter() {
      (this.input_date = moment()),
        (this.input_date_final = moment()),
        (this.input_folio = "");
      this.selectClient = "";
      this.input_orden = "";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.resKey++;
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      this.loadingData = true;

      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }
      let arrayFilter = this.pagos;
      if (this.transaccion) {
        arrayFilter = arrayFilter.map((pago) => {
          return pago + "-" + this.transaccion;
        });
      }
      let listVentas = [];
      let data_ventas = [];
      if (this.input_folio != "") {
        const firestore = this.$store.getters.getFirebaseApp.firestore;

        let filter = [
          firestore.where("Folio", "==", this.input_folio),
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];
        const data = await firestore.queryBuilder("PDV_CXCTemp", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
          return { id: doc.ref.id, ...doc.data() };
        });
        data_ventas = listVentas;
      } else {
        let taskTurnos = turnos.map(async (id) => {
          const firestore = this.$store.getters.getFirebaseApp.firestore;
          let filter = [
            firestore.where("Turno", "==", id),

            firestore.where(
              "Tenant",
              "==",
              this.$store.getters.getFirebaseApp.tenant
            ),
          ];

          if (this.selectDep != "ALL" && this.selectDep != "") {
            filter.push(firestore.where("Departamento", "==", this.selectDep));
          }
          /*if (arrayFilter.length > 0) {
        filter.push(
          firestore.where("_PagoIdx", "array-contains-any", arrayFilter)
        );
      }*/

          if (this.input_folio != "") {
            filter.push(firestore.where("Folio", "==", this.input_folio));
          }

          if (this.input_orden != "") {
            filter.push(firestore.where("Orden", "==", this.input_orden));
          }

          if (this.selectClient != "") {
            filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
          }

          const data = await firestore.queryBuilder("PDV_CXCTemp", filter);
          let preData = [];
          preData = data.docs.map((doc) => {
            listVentas.push({ id: doc.ref.id, ...doc.data() });
            return { id: doc.ref.id, ...doc.data() };
          });
        });

        await Promise.all(taskTurnos).then((turnos) => {
          data_ventas = listVentas;
        });
      }

      const cajasMap = this.$pgsHelper.createIndex(this.data_cajas, 'id');
      const cashiersMap = this.$pgsHelper.createIndex(this.cashiers, 'Id');
      data_ventas.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
        item.NombreCliente = item.Cliente.Nombre;
        item.AliasVenta = item.Cliente.Apodo;
        item.CajaName = (cajasMap.get(item.Caja) || {}).Nomb || '';
        item.CajeroName = (cashiersMap.get(item.Cajero) || {}).Nomb || '';
        item.Catalogo.forEach((prod) => {
          prod.ivaPercent = this.$pgsHelper.getIvaByFamilia(
            this.familias,
            prod.Familia.I
          );
        });
      });
      this.data_ventas = this.$_.orderBy(data_ventas, "fecha", "desc");
      this.showEstad = true;
      this.loadingData = false;
      this.keyResume++;
      this.processAllSales();
    },

    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      if (data.exists()) {
        this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
      }
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {

          if (!mesero.Deptos) {
            mesero.DepartamentoText = "";
            return;
          }
          let deptos = Object.entries(mesero.Deptos);
          let textDepto = "";
          deptos.forEach((depto) => {
            let testDepto = this.$pgsHelper.getById(
              this.departamentos,
              "Id",
              depto[0]
            );
            if (testDepto) {
              textDepto = textDepto + testDepto.Nombre + " ";
            }
          });
          mesero.DepartamentoText = textDepto;
        });
      }
    },
  },
  beforeCreate: function () { },
  beforeMount: async function () {
    await this.getAperturas();
    await this.getFamilias();
    await this.getMeserosAB();
    this.getVentas();
    this.getCajas();
    this.getCashiers();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
